import { useMemberExperienceAuth } from '@guildeducationinc/auth-frontend-tools';
import { FeedbackWidget } from 'src/remotes/FeedbackWidget';
import React from 'react';
import styles from './CatalogFeedbackWidget.module.scss';

export const CatalogFeedbackWidget: React.FC = () => {
	const { userFromIdToken: authUser } = useMemberExperienceAuth();

	return (
		<FeedbackWidget
			analytics={window.analytics}
			className={styles.feedbackWidget}
			data-testid='feedback-widget'
			user={{
				email: authUser.email,
				employeeId: authUser.employee_id,
				employerId: authUser.employer_uuid,
				employerName: authUser.employer,
				id: authUser.id,
			}}
		/>
	);
};
